/*
 * @Author: your name
 * @Date: 2020-11-06 17:28:06
 * @LastEditTime: 2020-11-19 11:20:51
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /DianZiDiTu/src/components/onlineMap/model/DataSource/OLSourceTypeJs.js
 */
export const OLSourceType =
{   
    source_vector:"Vector",


    source_cluster:"Cluster",

    source_vectorTile:"VectorTile",

    source_wmts:"WMTS",

    source_wms:"wms",

    source_xyz:"XYZ"

}
